import type { BoardsPage, LocationType } from '../../model/index.tsx';
import get from '../../rest/search-boards/get/index.tsx';
import { transformSearchResponseBoards } from './transformers.tsx';

const searchBoards = async (
	baseUrl: string,
	search?: string,
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	locationType: LocationType,
	locationKey: string,
	negateLocationFiltering = false,
	startAt = 0,
): Promise<BoardsPage> => {
	const response = await get(
		baseUrl,
		search,
		locationType,
		locationKey,
		negateLocationFiltering,
		startAt,
	);

	return transformSearchResponseBoards(response);
};

export default searchBoards;
